import dayjs from "dayjs";

export const createTimeRange = (delayDay: number, spaceDay: number) => {
  const startDate = dayjs(dayjs().unix() * 1000 + delayDay * 24 * 3600 * 1000).format("YYYY-MM-DD");
  const endDate = dayjs(startDate).add(spaceDay, "days").format("YYYY-MM-DD");

  return {
    startDate,
    endDate,
  };
};
